module.exports = __webpack_public_path__ + "static/media/study 220209.13514384.png";